import axiosApiInstance from "../../../../helpers/axiosPdfConfig";
import setAlertMessage from "../../Alert/alert";

const PdfTranscript = (apiLink, filename, dispatch, setState) => {

  axiosApiInstance
    .post(apiLink)
    .then(res => {
      const pdfFile = new Blob([res.data], {type: 'application/pdf'});
      const url = window.URL.createObjectURL(pdfFile);
      const link = document.createElement("a");

      link.href = url;
      link.downloads = filename;
      link.target = '_blank';
      document.body.appendChild(link);

      link.click();
      link.remove();


      dispatch({type: "GLOBAL_UPDATE", global_update: true});
    })
    .catch((_error) => {
      const msg = {
        type: 'error',
        message: 'An error has occurred while trying to generate the transcript.'
      }
      dispatch({type: "GLOBAL_UPDATE", global_update: true});

      setAlertMessage(msg, setState);
    });
}

export default PdfTranscript;